import Help from '../../modules/Help/Help';

function PageSupport() {
    return <Help />;
}

export default PageSupport;
